export default __webpack_public_path__ + "static/media/SYME_Green_Logo_With_Sub.6687b748.svg";